import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { DarkModeSwitch } from "react-toggle-dark-mode";
import { setTheme } from "../../redux/actions/globalAction";

export const HeaderSection = ({ title }) => {
  const theme = useSelector((state) => state.globalReducer.theme);
  const dispatch = useDispatch();

  return (
    <div style={{ flexDirection: "row" }}>
      <header>
        <DarkModeSwitch
          style={{ marginBottom: "2rem" }}
          checked={theme === "dark"}
          size={30}
          onChange={() =>
            dispatch(setTheme(theme === "dark" ? "light" : "dark"))
          }
        />
        <h2 className="h2 article-title">{title}</h2>
      </header>
    </div>
  );
};
